import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from "../src/locales/ar/tanslation.json"
import en from "../src/locales/en/translation.json"

import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next).init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },

            lng: 'ar',
            fallbackLng: 'ar',
            interpolation: {
                escapeValue: false,
            },
            detection: {
                order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
                caches: ['localStorage', 'cookie'],
            },
        }
    });

export default i18n;
